import { make_staircase, time_mul_1k, normalize_time, } from './common';
import { GraphSource } from './base';
import { LoadDataType } from '../load-types';
const _colors = [
    '#067c04',
    '#b20c14',
    '#cf0bed',
    '#efc715',
    '#05738e',
    '#717c08',
    '#049b7f',
    '#dd7104',
    '#6c0499',
    '#027f02',
    '#06617a',
    '#ad0526',
    '#0c9b70',
    '#d613ab',
    '#1a0782',
];
export class CustomControlStatusGraphSource extends GraphSource {
    class_name() {
        return 'CustomControlStatusGraphSource';
    }
    control_no;
    _control_spec;
    constructor(device, { control_no, color }) {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        super(...arguments);
        this.control_no = control_no;
        this._control_spec = device.custom_controls()?.[this.control_no];
    }
    status_spec() {
        return this._control_spec?.statuses?.[0];
    }
    color() {
        if (this._color)
            return this._color;
        else
            return _colors[this.control_no];
    }
    title() {
        return this.status_spec()?.name ?? `статус ${this.control_no + 1}`;
    }
    // show_in_legend: -> @_normalized_data?.length > 0
    serialize_params() {
        return { control_no: this.control_no, color: this._color };
    }
    is_same(other) {
        return (this.constructor === other.constructor &&
            this.control_no === other.control_no);
    }
    yaxis_key() {
        return 'onoff';
    }
    data_source_key() {
        return LoadDataType.custom_controls;
    }
    extract_data(raw_data) {
        return raw_data;
    }
    normalize_data(data) {
        if (JSON.stringify(data) === '{}')
            return null;
        data = make_staircase(time_mul_1k(normalize_time(data, 0)));
        const status_id = this.status_spec()?.id;
        if (status_id == null)
            return null;
        const mask = 1 << status_id;
        const active_value = this.status_spec()?.active_value ?? 1;
        for (const item of data) {
            const value = (item[1] & mask) !== 0 ? 1 : 0;
            item[1] = ~~(value === active_value);
        }
        return data;
    }
    dont_downsample() {
        return true;
    }
}
